module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }), _vm._v("PATRIOTIC GORE")]), _vm._v(" "), _c('p', {
    staticClass: "tp-center"
  }, [_vm._v("STUDIES IN THE LITERATURE"), _c('br'), _vm._v("OF THE AMERICAN CIVIL WAR")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("BY")]), _vm._v(" "), _c('p', {
    staticClass: "tp-center"
  }, [_vm._v("EDMUND WILSON")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Without the shedding of blood, there is no remission of sins")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN BROWN")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('i', [_vm._v("The despot’s heel is on thy shore,")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('i', [_vm._v("Maryland!")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('i', [_vm._v("His torch is at thy temple door,")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Maryland!")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('i', [_vm._v("Avenge the patriotic gore")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('i', [_vm._v("That flecked the streets of Baltimore,")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('i', [_vm._v("And be the battle-queen of yore,")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Maryland! My Maryland!")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SONG OF THE CONFEDERATE SOUTH")])])]), _vm._v(" "), _c('p', {
    staticClass: "tp-center1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.jpg"
    }
  }), _c('br'), _vm._v("Farrar, Straus & Giroux")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a4834e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 60
// module chunks = 0